import React, { FC } from 'react';
import classNames from 'classnames';
import ValidationMessage from '../ValidationMessage';
import { TEXTAREA_LENGTH } from '../../const/constants';
import { FieldProps } from '../models';
import './TextareaField.scss';

const TextareaField: FC<FieldProps> = ({
  label,
  id,
  ariaLabel,
  errorMessage,
  placeholder,
  ts,
  value,
  ...other
}) => {
  const checkTextareaSize = (text: string, translation: string) =>
    text?.length < TEXTAREA_LENGTH ? (
      <p className="textarea-field__remaining-signs">
        <span>{`${TEXTAREA_LENGTH - value.length} `}</span>
        {translation}
      </p>
    ) : (
      ''
    );
  const errorMessageId = `${id}Error`;

  return (
    <div className="textarea-wrapper">
      <div
        className={classNames('form-field textarea-field', {
          'textarea-field__error': errorMessage,
        })}
      >
        <label className="form-field__label" htmlFor={id}>
          {ts[label]}
        </label>
        <textarea
          id={id}
          aria-invalid={!!errorMessage}
          aria-describedby={errorMessageId}
          aria-label={ts[ariaLabel]}
          {...(placeholder && { placeholder: ts[placeholder] })}
          rows={4}
          value={value}
          {...other}
        />
      </div>
      {checkTextareaSize(value, ts.remainingCharacters)}
      {errorMessage && (
        <ValidationMessage errorId={errorMessageId} errorMessage={ts[errorMessage]} />
      )}
    </div>
  );
};

export default TextareaField;
